import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const quickLinks = [
  { label: "事件复盘列表", path: "/topics" },
  { label: "关于我们", path: "/about" },
  { label: "常见问题", path: "/faq" },
  { label: "联系我们", path: "/contact" },
];

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面不存在 - 诱惑吃瓜"
        description="你访问的页面不存在或已被移除，可以返回首页，或前往事件复盘列表继续浏览。"
        path="/"
      />
      <SiteHeader />
      <main className="flex min-h-[74vh] items-center justify-center bg-background-100 px-4 py-32">
        <div className="w-full max-w-2xl text-center">
          <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面不存在
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            页面可能已经调整或下线。你访问的地址是
            <span className="mx-1 rounded bg-background-200 px-2 py-0.5 text-xs text-foreground-700">
              {location.pathname}
            </span>
            ，试试从下面这些入口重新开始。
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            {quickLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="inline-block cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ))}
          </div>

          <Link
            to="/"
            className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}